const quantityInputId = document.getElementById("quantity-input-id");
const quantityInput =
  quantityInputId && quantityInputId.value
    ? document.getElementById(quantityInputId.value)
    : null;

const perBoxInput = document.getElementById("em-quantity-per-box");
const perBoxValue = perBoxInput ? perBoxInput.value : null;

const boxPriceInput = document.getElementById("em-quantity-box-price");
const boxPriceValue = boxPriceInput ? boxPriceInput.value : null;

const areaInput = document.getElementById("em-quantity-area");
const overageInput = document.getElementById("em-quantity-overage");

const summarySutotalElement = document.getElementById("em-quantity-summary-subtotal");
const summaryWasteElement = document.getElementById('em-quantity-summary-waste');
const summarytotalElement = document.getElementById('em-quantity-summary-total');
const summaryBoxesElement = document.getElementById('em-quantity-summary-boxes');
const summaryAreaElement = document.getElementById('em-quantity-summary-area');

const totalAreaElement = document.getElementById("em-quantity-total-area");
const totalBoxesElement = document.getElementById('em-quantity-total-boxes');
const totalPriceElement = document.getElementById('em-quantity-total-price');

const calculator = document.querySelector('.em-quantity-calculator');
const calculatorOpen = document.getElementById('em-quantity-calculator-open');
const calculatorClose = document.getElementById('em-quantity-calculator-close');
const calculatorButton = document.getElementById('em-quantity-calculator-button');
const calculatorLength = document.getElementById('em-quantity-calculator-length');
const calculatorWidth = document.getElementById('em-quantity-calculator-width');
const calculatorFooter = document.querySelector('.em-quantity-calculator-footer');

function emQuantityRealculate(e) {
  let area = parseFloat(areaInput.value);
  area = area ? area : 0;
  
  let overage = parseInt(overageInput.value);
  overage = overage ? overage : 0;
  
  const quantity = (area / perBoxValue) * (1 + overage / 100);
  quantityInput.value = Math.ceil(quantity ? quantity : 1);

  emQuantityUpdate();
}

function emQuantityInputChange(e) {
  let quantity = parseInt(quantityInput.value, 10);
  quantity = quantity ? quantity : 1;

  const area = quantity * perBoxValue;
  areaInput.value = Math.round(area);

  emQuantityUpdate();
}

function emQuantityUpdate() {
  let overage = parseInt(overageInput.value);
  overage = overage ? overage : 0;

  let area = parseFloat(areaInput.value);
  area = area ? area : 0;

  let quantity = parseInt(quantityInput.value, 10);
  quantity = quantity ? quantity : 1;

  const price = quantity * boxPriceValue / 100.0;

  const waste = area * (overage / 100);
  const totalArea = quantity * perBoxValue;

  summarySutotalElement.innerHTML = parseFloat(area.toFixed(1));
  summaryWasteElement.innerHTML = parseFloat(waste.toFixed(1));
  summarytotalElement.innerHTML = parseFloat((area + waste).toFixed(1));
  summaryBoxesElement.innerHTML = quantity;
  summaryAreaElement.innerHTML = parseFloat(totalArea.toFixed(2));

  totalAreaElement.innerHTML = parseFloat(totalArea.toFixed(2));
  totalBoxesElement.innerHTML = quantity;
  totalPriceElement.innerHTML = `$${price.toLocaleString(undefined, { minimumFractionDigits: 2 })} USD`;;
}

if (perBoxInput && areaInput && overageInput) {
  quantityInput.addEventListener("input", emQuantityInputChange);

  areaInput.addEventListener("input", emQuantityRealculate);
  overageInput.addEventListener("input", emQuantityRealculate);

  emQuantityUpdate();
}

if (calculatorOpen && calculatorClose) {
  calculatorOpen.addEventListener("click", function() {
    calculator.classList.add('em-quantity-calculator--open');
  });

  calculatorClose.addEventListener("click", function() {
    calculator.classList.remove('em-quantity-calculator--open');
    calculator.classList.remove('em-quantity-calculator--done');
  });
}

if (calculatorButton && calculatorLength && calculatorWidth) {
  calculatorButton.addEventListener("click", function() {
    let length = parseFloat(calculatorLength.value);
    length = length ? length : 0;
    let width = parseFloat(calculatorWidth.value);
    width = width ? width : 0;

    const area = length * width;
    if (area > 0) {
      areaInput.value = Math.round(area);
      emQuantityRealculate();

      const unit = calculatorFooter.getAttribute('data-unit');
      const quantity = parseInt(quantityInput.value);
      quantity = quantity ? quantity : 1;
      let overage = overageInput.value;
      overage = overage ? overage : 0;
      const quantityNet = quantity / (1 + overage / 100);
      
      let footerText = `You need ${Math.ceil(quantityNet)} ${unit}.`;
      if (overage > 0) {
        footerText += ` We recommended that you order ${Math.ceil(quantity)} ${unit} (${overage}% extra) to cover cuts and future repairs.`
      }

      calculatorFooter.innerHTML = footerText;

      calculator.classList.add('em-quantity-calculator--done');
    }
  });
}
